module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 18.61c0-6.644-4.25-12.236-10.06-14.012.028-.198.06-.394.06-.598a4 4 0 0 0-8 0c0 .204.032.4.06.598C6.25 6.374 2 11.964 2 18.61V24H1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h11a4 4 0 0 0 8 0h11a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-1v-5.39z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/bell-1.js
// module id = 1008
// module chunks = 14